export default __webpack_public_path__ + "static/media/pipelineplus-mark.313d51f5.svg";